import {
  BookOpenIcon,
  Grid2X2Icon,
  ListIcon,
  type LucideIcon,
  NetworkIcon,
  ShieldCheckIcon,
} from "lucide-react"
import {
  browseNavigationLinks,
  freeToolNavigationLinks,
  priorityHubLinks,
} from "~/config/navigation-links"

/** A single navigation link. Labels are i18n keys, resolved at render. */
export interface NavEntry {
  href: string
  labelKey: string
  icon: LucideIcon
  badgeKey?: string
}

/** The promotional panel shown alongside a dropdown menu's links on desktop. */
export interface NavPromo {
  href: string
  titleKey: string
  descKey: string
  ctaKey: string
}

/** A group of links, rendered as a titled section on mobile. */
export interface NavGroup {
  labelKey: string
  items: NavEntry[]
  menu?: boolean // Render as a dropdown menu on desktop instead of flat top-level links.
  eyebrowKey?: string
  promo?: NavPromo
}

/** Shared desktop and mobile navigation: discover, learn, then use a utility. */
export const navigation: NavGroup[] = [
  {
    labelKey: "navigation.browse",
    items: browseNavigationLinks.map(link => ({
      ...link,
      icon: link.href === "/tools" ? ListIcon : Grid2X2Icon,
    })),
  },
  {
    labelKey: "navigation.hubs",
    menu: true,
    items: priorityHubLinks.map(link => ({
      href: link.href,
      labelKey: `navigation.guide_labels.${link.href.split("/").at(-1)}`,
      icon: BookOpenIcon,
    })),
  },
  {
    labelKey: "navigation.free_tools",
    menu: true,
    items: freeToolNavigationLinks.map(link => ({
      ...link,
      icon: link.href === "/ai-crawler-checker" ? ShieldCheckIcon : NetworkIcon,
    })),
  },
]
